<template>
  <div id="abstract-management">
    
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button icon="el-icon-s-tools" type="success" size="small" round @click="modalVisible = true"> {{$t('pages.event.abstractManagement.abstractSettings')}}</el-button>
          </li>
        </ul>
      </portal>

    <div class="content-wrapper">
      <portal to="action-buttons"></portal>
      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
           <div class="card-title-container">
              <h5 class="card-title">{{ this.$t('event.menu.controlpoints.title') }}</h5>
              <span v-html="$t('totalContent', [$store.state.venues.items.length])"></span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group> 
            </div>

          </div>
          
          <div class="card-body">

          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="$t('pages.event.abstractManagement.abstractSettings')" class="large" center modal-append-to-body destroy-on-close>
      <AbstractSettings @closeDialog="modalVisible = false" v-if="modalVisible" />
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import AbstractSettings from "../../components/abstract/AbstractSettings.vue"
export default {
  metaInfo: {
    title: "Abstract Management",
  },
  components: {
    AbstractSettings,
  },
  name: "AbstractManagement",
  data() {
    return {
      modalVisible:false,
      loading:false,
      helpUrl:null,
    }

  },
  methods: {
    refreshList(){
      console.log('TODO Refresh List');
    },
  },
  mounted() {
  },
  created() {},
  computed: {

  },
  watch: {

  },
};
</script>
<style lang="less">
.modal-base-mid {
  min-width:1140px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/event/AbstractManagement.vue